import { Action } from "redux";
import * as toastr from "toastr";
import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

// import SearchToolbarApi from "../api/mockSearchToolbarApi"; // To be deactivated and replaced with DataService.
import { DataService } from "../data/DataService";

import { ICalendarSettings, ICalendarSettingsFromService, IOptionsResponse } from "../classes/data";
import { IOption } from "../classes/option";
import * as types from "./actionTypes";

import { beginAjaxCall } from "./ajaxActions";

const actionCreator = actionCreatorFactory();

export interface ISetSearchActionPayload {
  searchText: string;
  searchFilter: string;
  searchCategory: string;
}

export const setSearch = actionCreator<ISetSearchActionPayload>(types.SET_SEARCH);
export const loadCalendarSettingsSuccess = actionCreator<ICalendarSettings>(types.LOAD_CALENDAR_SETTINGS_SUCCESS);

const dataService = new DataService();

export function requestAdditonalCalendarSettingsFromService(portletInstanceId: number, calendarId: number) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.calendarSettings(portletInstanceId, calendarId).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      const calSettingsFromService: ICalendarSettingsFromService = response;

      // Create empty calendar settings object.
      const calSettings: ICalendarSettings = {
        calendarName: "",
        categoryOptions: [],
        filterOptions: [],
        hasCreatePermission: false,
        hasDeletePermission: false,
        hasEditPermission: false,
        isTwoWayCalendar: false,
        text: {},
        useModernAddAndEditEventScreen: false,
        userDateFormat: "",
        viewModeOptions: [],
      };

      // Verify incoming data, and pop it into the calendar settings.
      calSettings.categoryOptions = verifyOptions("category options", calSettingsFromService.categoryOptions);
      calSettings.filterOptions = verifyOptions("filter options", calSettingsFromService.filterOptions);
      calSettings.hasCreatePermission = calSettingsFromService.hasCreatePermission;
      calSettings.hasDeletePermission = calSettingsFromService.hasDeletePermission;
      calSettings.hasEditPermission = calSettingsFromService.hasEditPermission;
      calSettings.isTwoWayCalendar = calSettingsFromService.isTwoWayCalendar;
      calSettings.text = calSettingsFromService.text;
      calSettings.userDateFormat = calSettingsFromService.userDateFormat;
      calSettings.calendarName = calSettingsFromService.calendarName;
      calSettings.useModernAddAndEditEventScreen = calSettingsFromService.useModernAddAndEditEventScreen;

      // Update the text for the view Modes object.
      const viewModeOptions: IOption[] = [
        // { text: response.text.mainToolbar.daily, value: "DAILY" },
        { text: calSettingsFromService.text.mainToolbar.dailyList, value: "DAILYLIST" },
        { text: calSettingsFromService.text.mainToolbar.weekly, value: "WEEKLY" },
        { text: calSettingsFromService.text.mainToolbar.monthly, value: "MONTHLY" },
        { text: calSettingsFromService.text.mainToolbar.monthlyList, value: "MONTHLYLIST" },
      ];
      calSettings.viewModeOptions = viewModeOptions;

      // If all's well, dispatch action with the calendar settings.
      dispatch(loadCalendarSettingsSuccess(calSettings));

    }).catch((error) => {
      toastr.error(error);
    });
  };
}

function verifyOptions(optionsName: string, rawOptions: IOption[]): IOption[] {

  if (!isIOptionsResponse(rawOptions)) {
    throw Error("The data returned for the " + optionsName + " is incomplete.");
  }

  let options: IOption[] = rawOptions;
  options = options.sort(optionSorter);
  return options;
}

function optionSorter(option1: IOption, option2: IOption): number {
  const t1 = option1.text.trim().toLowerCase();
  const t2 = option2.text.trim().toLowerCase();
  if (t1 > t2) {
    return 1;
  } else if (t1 < t2) {
    return -1;
  } else {
    return 0;
  }
}

function isIOptionsResponse(data: any): data is IOptionsResponse {
  // Check options is an array, and contains option objects.
  if (Array.isArray(data)) {
    for (const option of data) {
      if (!isIOption(option)) { return false; }
    }
  } else {
    return false;
  }

  return true;
}

function isIOption(data: any): data is IOption {
  if (data.text === undefined) { return false; }
  if (data.value === undefined) { return false; }
  return true;
}
